export default "__VITE_ASSET__Dw4ZGI1j__"